import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Icon } from '@iconify/react';
import { useSelector } from 'react-redux';
import warningIcon from '../common/asset1/warning-symbol.svg';
import successtick from '../common/asset1/tick-mark.png'; 

const DeActStaff = () => {
  const navigate = useNavigate();
  const additionalCustomerId = useSelector((state) => state.auth.additionalCustomerId);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const userToken = useSelector((state) => state.auth.token);
  const [formData, setFormData] = useState({
    staffName: '',
    closureReason: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.staffName) {
      newErrors.staffName = 'Staff name is required.';
    }
    if (!formData.closureReason) {
      newErrors.closureReason = 'Closure reason is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!additionalCustomerId) {
      setErrors((prev) => ({
        ...prev,
        general: 'Customer ID is missing. Please ensure the customer is selected.',
      }));
      return;
    }

    try {
      const payload = {
        customerId: additionalCustomerId.customerId || additionalCustomerId,
        staffName: formData.staffName,
        closureReason: formData.closureReason,
      };

      console.log('Payload:', payload);

      const response = await axios.post(
        'https://localhost:7040/api/account/deactivate/account',
        payload,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      

      if (response.status === 200) {
        setIsSubmitted(true); 
      }
    } catch (err) {
      console.error('Error deactivating account:', err.response?.data || err.message);
      setErrors((prev) => ({
        ...prev,
        general: 'Failed to deactivate account. Please try again.',
      }));
    }
  };

  const onClickGoBack = () => {
    navigate('/admin/home/viewing-user-profile');
  };

  return (
    <div className="close-use-out">
      <div className="close-form-go-back">
        <button className="get-back-out" onClick={onClickGoBack}>
          <Icon icon="iconamoon:arrow-left-2-bold" className="go-back-symbol" />
          Go Back
        </button>
      </div>

      {!isSubmitted ? (
        <div className="close-form-staff">
          <label>
            Handling for Closure
            <input
              type="text"
              name="staffName"
              placeholder="Handling for Closure"
              value={formData.staffName}
              onChange={handleInputChange}
            />
            {errors.staffName && (
              <div className="error-reg-icon-out">
                <img
                  src={warningIcon}
                  alt="Warning-Icon"
                  className="warning-icon"
                />
                <span className="error-register-now">{errors.staffName}</span>
              </div>
            )}
          </label>

          <label>
            Reason for Closure
            <input
              type="text"
              name="closureReason"
              placeholder="Reason for Closure"
              value={formData.closureReason}
              onChange={handleInputChange}
            />
            {errors.closureReason && (
              <div className="error-reg-icon-out">
                <img
                  src={warningIcon}
                  alt="Warning-Icon"
                  className="warning-icon"
                />
                <span className="error-register-now">{errors.closureReason}</span>
              </div>
            )}
          </label>

          {errors.general && <p className="error">{errors.general}</p>}

          <button className="close-proceed" onClick={handleSubmit}>
            Deactivate Account
          </button>
        </div>
      ) : (
        <div className="success-message-teeny-cont">
          <div className="success-icon-wrapper">
            <img src={successtick} alt="success-mark" className="success-tick-mark" />
          </div>
          <p>Account deactivated successfully!</p>
          <div className="created-name-id-out">
            <div className="created-name-id">
              <label>Name: </label>
              <span>{formData.staffName}</span>
            </div>
            <div>
              <label>Customer ID: </label>
              <span>{formData.customerId?.customerId || formData.customerId}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeActStaff;
